import React from "react";

interface IconProps {
  width?: number;
  height?: number;
  color?: string;
  onClick?: () => void;
}

const MenuIcon: React.FC<IconProps> = ({
  width = 25,
  height = 25,
  color = "rgb(69, 110, 141)",
  onClick = () => {},
}) => {
  return (
    <svg
      width={width}
      height={height}
      onClick={onClick}
      viewBox="0 0 24.75 24.75"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M0,3.875c0-1.104,0.896-2,2-2h20.75c1.104,0,2,0.896,2,2s-0.896,2-2,2H2C0.896,5.875,0,4.979,0,3.875z 
           M22.75,10.375H2c-1.104,0-2,0.896-2,2c0,1.104,0.896,2,2,2h20.75c1.104,0,2-0.896,2-2
           C24.75,11.271,23.855,10.375,22.75,10.375z 
           M22.75,18.875H2c-1.104,0-2,0.896-2,2s0.896,2,2,2h20.75c1.104,0,2-0.896,2-2
           S23.855,18.875,22.75,18.875z"
        fill={color}
      />
    </svg>
  );
};

export default MenuIcon;
